import { EQueue } from "./EQueue";
import { WidgetType } from "src/Types/ReDoc/EQueue";

import { ReactComponent as InviteIcon }  from './Assets/queue_invite.svg';
import { ReactComponent as InviteNumberIcon }  from './Assets/queue_invite-number.svg';
import { ReactComponent as CupIcon }  from './Assets/queue_cup.svg';
import { ReactComponent as ExitIcon }  from './Assets/queue_exit.svg';

import { ReactComponent as AppearIcon }  from './Assets/queue_appear.svg';
import { ReactComponent as RepeatIcon }  from './Assets/queue_repeat.svg';
import { ReactComponent as NotAppearIcon }  from './Assets/queue_notAppear.svg';

import { ReactComponent as PostponeIcon }  from './Assets/queue_postpone.svg';
import { ReactComponent as RedirectIcon }  from './Assets/queue_redirect.svg';
import { ReactComponent as EndServiceIcon }  from './Assets/queue_end-service.svg';

import { ReactComponent as CancelCapIcon }  from './Assets/queue_cap_cancel.svg';

import { ReactComponent as ExitCapIcon } from './Assets/Cup-modal.svg';
import { ReactComponent as BExitIcon } from './Assets/Exit.svg';
import { ReactComponent as CancelCallIcon } from './Assets/account-remove.svg';

/** Icons for Re:Turn widget */
import { ReactComponent as RedirectReTurnIcon } from './Assets/ReTurnQueue/RedirectReTurn.svg';
import { ReactComponent as CallAnotherReTurnIcon } from './Assets/ReTurnQueue/CallAnotherReTurn.svg';
import { ReactComponent as CallReTurnIcon } from './Assets/ReTurnQueue/CallReTurn.svg';
import { ReactComponent as FinishWorkReTurnIcon } from './Assets/ReTurnQueue/FinishWorkReTurn.svg';
import { ReactComponent as GoRestIcon } from './Assets/ReTurnQueue/GoRestReTurn.svg';
import { ReactComponent as OpenWindowReTurnIcon } from './Assets/ReTurnQueue/OpenWindowReTurn.svg';
import { ReactComponent as ScheduleReTurnIcon } from './Assets/ReTurnQueue/ScheduleReTurn.svg';
import { ReactComponent as StopCallReTurnIcon } from './Assets/ReTurnQueue/StopCallReTurn.svg';
import { ReactComponent as StopReceptionReTurnIcon } from './Assets/ReTurnQueue/StopReceptionReTurn.svg';
import { ReactComponent as FinishRestReTurnIcon } from './Assets/ReTurnQueue/FinishRestReturn.svg';



export type EQActionType = {
	name: string;
	title?: string;
	icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	subAction?: Array<EQActionType>;
	disabled?: boolean;
};

export type EQStateType = {
	text: string;
	color: string;
	borderTopColor?: string;
	badgeBackgroundColor?: string;
	hideQueueInfo?: boolean;
	hideAutoCall?: boolean;
	hideServiceLabel?: boolean;
	introText?: string;
	showQueueStats?: boolean;
	wide?: boolean;
	small?: boolean;
	medium?: boolean;
	compact?: boolean;
	actions?: Array<EQActionType>;
};

export type EQStatesType = {
	[key: number]: EQStateType;
};

export type ReturnViewMode = "inactive" | "free" | "confirming" | "called" | "working" | "pause";
export type ReturnEQStatesType = Record<ReturnViewMode, EQStateType>;

export const EQStates: EQStatesType = {
	[WidgetType.None]: {
		text: "",
		color: ""
	},
	[WidgetType.Waiting]: {
		text: "Вызвать посетителя",
		color: "#42CD69",
		actions: [
			{
				name: "invite",
				title: "Пригласить посетителя",
				icon: InviteIcon
			},
			{
				name: "asc-inviteByNumber",
				title: "Пригласить посетителя по номеру",
				icon: InviteNumberIcon
			},
			{
				name: "cap",
				title: "Перерыв",
				icon: CupIcon
			},
			{
				name: "asc-exit",
				title: "Выйти",
				icon: ExitIcon
			}
		]
	},
	[WidgetType.Calling]: {
		text: "Ожидание посетителя",
		color: "#FFA900",
		actions: [
			{
				name: "beginServing",
				title: "Посетитель явился",
				icon: AppearIcon
			},
			{
				name: "repeatCall",
				title: "Повторный вызов",
				icon: RepeatIcon
			},
			{
				name: "asc-notAppear",
				title: "Заявитель не явился",
				icon: NotAppearIcon
			}
		]
	},
	[WidgetType.Working]: {
		text: "Работа с посетителем",
		color: "var( --Status-error, #EF4444 )",
		actions: [
			{
				name: "asc-delay",
				title: "Отложить прием посетителя",
				icon: PostponeIcon
			},
			{
				name: "asc-redirect",
				title: "Перенаправить посетителя",
				icon: RedirectIcon
			},
			{
				name: "endService",
				title: "Завершить обслуживание посетителя",
				icon: EndServiceIcon,
				subAction: [
					{
						name: "endServiceAndInviteByNumber",
						title: "Завершить обслуживание посетителя и вызвать посетителя по номеру",
						icon: InviteNumberIcon
					},
					{
						name: "endServiceAndCap",
						title: "Завершить обслуживание посетителя и уйти на перерыв",
						icon: CupIcon
					},
					{
						name: "endServiceAndExit",
						title: "Завершить обслуживание посетителя и выйти",
						icon: ExitIcon
					}
				]
			}
		]
	},
	[WidgetType.OnPause]: {
		text: "Перерыв",
		color: "#828F9C",
		actions: [
			{
				name: "cancelCap",
				title: "Завершить перерыв",
				icon: CancelCapIcon
			}
		]
	},
	[WidgetType.Unknown]: {
		text: "",
		color: ""
	}
};

/** Детальная карта состояний re:turn для кастомного виджета (с плейсхолдерами) */
export const ReturnEQViewStates: ReturnEQStatesType = {
	inactive: {
		text: "Окно неактивно",
		color: "#748398",
		borderTopColor: "var(--text-icons-tai-secondary, #748398)",
		hideAutoCall: true,
		introText: "Здравствуйте!\nХорошего рабочего дня!",
		actions: [
			{
				name: "return-open-window",
				title: "Выбрать окно",
				icon: OpenWindowReTurnIcon
			}
		]
	},
	free: {
		text: "Окно свободно",
		color: "#1D7235",
		borderTopColor: "var(--Status-success-hover, #1D7235)",
		badgeBackgroundColor: "var(--Status-completed, #BCE0CA)",
		showQueueStats: true,
		actions: [
			{
				name: "return-invite",
				title: "Вызвать",
				icon: CallReTurnIcon,
				subAction: [
					{
						name: "return-invite-queue",
						title: "В порядке очереди",
					},
					{
						name: "return-invite-ticket",
						title: "По номеру талону",
					}
				]
			},
			{
				name: "schedule",
				title: "Расписание",
				icon: ScheduleReTurnIcon
			},
			{
				name: "goRest",
				title: "Уйти на перерыв",
				icon: GoRestIcon
			},
			{
				name: "finishWork",
				title: "Завершить работу",
				icon: FinishWorkReTurnIcon
			}
		]
	},
	confirming: {
		text: "Подтверждение вызова",
		color: "#1D7235",
		borderTopColor: "var(--Status-success-hover, #1D7235)",
		badgeBackgroundColor: "var(--Status-completed, #BCE0CA)",
		hideServiceLabel: true,
		actions: [
			{
				name: "return-confirm",
				title: "Подтвердить",
				icon: CallReTurnIcon
			},
			{
				name: "return-invite-another",
				title: "Вызвать другого",
				icon: CallAnotherReTurnIcon
			},
			{
				name: "return-stop-call",
				title: "Прекратить вызов",
				icon: StopCallReTurnIcon
			}
		]
	},
	called: {
		text: "Посетитель вызван",
		color: "#D37406",
		borderTopColor: " #D37406",
		badgeBackgroundColor: "var(--Status-warning-soft, #FDEFCC)",
		actions: [
			{
				name: "beginServing",
				title: "Начать приём",
				icon: CallReTurnIcon
			},
			{
				name: "return-repeat-call",
				title: "Вызвать повторно",
				icon: CallAnotherReTurnIcon
			},
			{
				name: "return-redirect",
				title: "Перенаправить",
				icon: RedirectReTurnIcon
			},
			{
				name: "return-stop-call",
				title: "Прекратить вызов",
				icon: StopCallReTurnIcon,
				subAction: [
					{
						name: "return-stop-call-notappear",
						title: "Неявка посетителя"
					},
					{
						name: "return-stop-call-rest",
						title: "Уйти на перерыв"
					},
					{
						name: "return-stop-call-finish",
						title: "Завершить работу"
					}
				]
			}
		]
	},
	working: {
		text: "Работа с посетителем",
		color: "#784BD1",
		borderTopColor: " #784BD1",
		badgeBackgroundColor: "rgba(120, 75, 209, 0.20)",
		medium: true,
		actions: [
			{
				name: "endService",
				title: "Завершить приём",
				icon: StopReceptionReTurnIcon
			},
			{
				name: "return-redirect",
				title: "Перенаправить",
				icon: RedirectReTurnIcon
			}
		]
	},
	pause: {
		text: "Перерыв",
		color: "#748398",
		borderTopColor: "var(--text-icons-tai-secondary, #748398)",
		small: true,
		actions: [
			{
				name: "endPause",
				title: "Закончить перерыв",
				icon: FinishRestReTurnIcon 
			},
			{
				name: "schedule",
				title: "Расписание",
				icon: ScheduleReTurnIcon
			}
		]
	}
};

export const enum EQModalStates {
	None,
	Login,
	AskCap,
	AskExitCap,
	AskCancelCall,
	QueueIsEmpty,
	AscCallByNumber,
	AskPostPone,
	AskRedirect,
	AskComplete,
	Exit,
	AskReturnPause,
	AskReturnEndPause,
	AskReturnWorkdayEnd,
	AskReturnTransfer,
	AskReturnCancelCall,
	AskReturnBreakFromCalling
};

export type EQModalType = {
	title: string;
	text: string;
	color: string;
	icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
	onCloseTitle?: string;
	onNextState: {
		title: string;
		onAction?: string;
	};
};

export type EQModalTypes = {
	[key: number]: EQModalType;
};

export const EQModals: EQModalTypes = {
	[EQModalStates.AskCap]: {
		title: "Уйти на перерыв",
		text: "Вы действительно хотите уйти на перерыв?",
		color: "error",
		// icon: CapIcon,
		onCloseTitle: "Отмена",
		onNextState: {
			title: "Уйти",
			onAction: "beginPause"
		}
	},
	[EQModalStates.AskExitCap]: {
		title: "Завершить перерыв",
		text: "Вы действительно хотите завершить перерыв?",
		color: "error",
		icon: ExitCapIcon,
		onCloseTitle: "Отмена",
		onNextState: {
			title: "Завершить",
			onAction: "endPause"
		}
	},
	[EQModalStates.AskCancelCall]: {
		title: "Отмена вызова посетителя",
		text: "Вы действительно хотите отменить вызов посетителя?",
		color: "error",
		icon: CancelCallIcon,
		onCloseTitle: "Закрыть",
		onNextState: {
			title: "Отменить",
			onAction: "notAppear"
		}
	},
	[EQModalStates.QueueIsEmpty]: {
		title: "Посетителей нет",
		text: "На данный момент посетителей нет. Попробуйте вызвать посетителя позже.",
		color: "error",
		icon: CancelCallIcon,
		onNextState: {
			title: "Закрыть"
		}
	},
	[EQModalStates.Exit]: {
		title: "Выйти из электронной очереди",
		text: "Вы действительно хотите выйти из электронной очереди?",
		color: "error",
		icon: BExitIcon,
		onCloseTitle: "Отмена",
		onNextState: {
			title: "Выйти",
			onAction: "exit"
		}
	}
};

export type PointType = {
	left: number;
	top: number;
};

export default EQueue;
